import { ApolloClient, InMemoryCache, ApolloCache } from '@apollo/client';
import { APP_VERSION } from 'config/constants';
import { createApolloLink } from './links';
import { dataIdFromObject, typePolicies } from './cacheConfig';
import { exposeApolloCacheDebugGlobal, isApolloCacheDebugGlobalEnabled } from './apolloDebugGlobal';
import { InstrumentedInMemoryCache } from './instrumentedCache';

const cache: ApolloCache<any> = isApolloCacheDebugGlobalEnabled()
  ? new InstrumentedInMemoryCache({ typePolicies, dataIdFromObject })
  : new InMemoryCache({ typePolicies, dataIdFromObject });

// Configure the ApolloClient with the default cache
const client: ApolloClient<any> = new ApolloClient({
  clientAwareness: {
    name: 'workspace',
    version: APP_VERSION,
  },
  link: createApolloLink(),
  cache,
  // This speeds up the initial load by 30%
  assumeImmutableResults: true,
});

exposeApolloCacheDebugGlobal(client);

export { client, cache };
